import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  phone: null,
  searchId: null,
  result: [],
  loadingResponse: false,
  resultError: null,
  phoneError: null,
}

const updateSearchContactsPhoneHandler = (state, action) => {
  state.phone = action.payload
}

const resetSearchConfigAndStartLoadingHandler = state => {
  state.searchId = null
  state.result = []
  state.loadingResponse = true
  state.phoneError = null
  state.resultError = null
}

const setSuccessSearchIdHandler = (state, action) => {
  state.searchId = action.payload
  state.phoneError = null
  state.resultError = null
}

const setSearchResultHandler = (state, action) => {
  state.result = action.payload
  state.loadingResponse = false
  state.phoneError = null
  state.resultError = null
}

const setSearchErrorHandler = (state, action) => {
  state.loadingResponse = false
  state.phoneError = action.payload
}

export const searchContactsSlice = createSlice({
  name: 'searchContacts',
  initialState,
  reducers: {
    updateSearchContactsPhone: updateSearchContactsPhoneHandler,
    resetSearchConfigAndStartLoading: resetSearchConfigAndStartLoadingHandler,
    clearSearchContacts: () => initialState,
    setSearchError: setSearchErrorHandler,
    setSuccessSearchId: setSuccessSearchIdHandler,
    setSearchResult: setSearchResultHandler,
  },
})

export const {
  clearSearchContacts,
  updateSearchContactsPhone,
  resetSearchConfigAndStartLoading,
  setSearchError,
  setSuccessSearchId,
  setSearchResult,
} = searchContactsSlice.actions

export default searchContactsSlice.reducer
